import React, { useEffect, useState } from "react";
import api from "../services/api";
import "./Proyectos.css";
import { obtenerFechaLocal, formatearFecha } from "../utils/dateUtils";

const Proyectos = () => {
  const [proyectos, setProyectos] = useState([]);
  const [estadisticas, setEstadisticas] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [config, setConfig] = useState(null); 
  
  // Filtros
  const [filtros, setFiltros] = useState({
    buscar: "",
    estado: "",
    prioridad: "",
    responsable: ""
  });

  // Vista (lista o tarjetas)
  const [vista, setVista] = useState("tarjetas");

  // ← AGREGAR ESTAS LÍNEAS
  useEffect(() => {
    cargarConfig();
  }, []);

  const cargarConfig = async () => {
    try {
      const res = await api.get('/configuracion');
      setConfig(res.data);
    } catch (error) {
      console.error('Error al cargar config:', error);
    }
  };

  const cargarProyectos = async () => {
    try {
      setLoading(true);
      setError(null);

      // Construir query params
      const params = new URLSearchParams();
      if (filtros.buscar) params.append("buscar", filtros.buscar);
      if (filtros.estado) params.append("estado", filtros.estado);
      if (filtros.prioridad) params.append("prioridad", filtros.prioridad);
      if (filtros.responsable) params.append("responsable", filtros.responsable);

      const [resProyectos, resEstadisticas] = await Promise.all([
        api.get(`/proyectos?${params.toString()}`),
        api.get("/proyectos/estadisticas")
      ]);

      setProyectos(resProyectos.data.proyectos || resProyectos.data);
      setEstadisticas(resEstadisticas.data);
    } catch (error) {
      console.error("Error cargando proyectos:", error);
      setError("Error al cargar los proyectos. Por favor, intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarProyectos();
  }, [filtros]);

  const handleFiltroChange = (e) => {
    setFiltros({
      ...filtros,
      [e.target.name]: e.target.value
    });
  };

  const limpiarFiltros = () => {
    setFiltros({
      buscar: "",
      estado: "",
      prioridad: "",
      responsable: ""
    });
  };

  const getEstadoColor = (estado) => {
    const colores = {
      activo: "#10b981",
      pausado: "#f59e0b",
      completado: "#3b82f6",
      cancelado: "#ef4444"
    };
    return colores[estado] || "#6b7280";
  };

  const getPrioridadColor = (prioridad) => {
    const colores = {
      baja: "#6b7280",
      media: "#3b82f6",
      alta: "#f59e0b",
      urgente: "#ef4444"
    };
    return colores[prioridad] || "#6b7280";
  };

  const formatearFechaProyecto = (fecha) => {
    if (!fecha) return "Sin definir";
    // Usamos la utilidad para evitar el desfase de zona horaria
    return formatearFecha(fecha); 
  };

  const calcularDiasRestantes = (fechaFin) => {
    if (!fechaFin) return null;
    const hoy = new Date();
    const fin = new Date(fechaFin);
    const diff = Math.ceil((fin - hoy) / (1000 * 60 * 60 * 24));
    return diff;
  };

  if (loading) {
    return (
      <div className="proyectos-container">
        <div className="loading">
          <div className="spinner"></div>
          <p>Cargando proyectos...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="proyectos-container">
        <div className="error-message">
          <span className="error-icon">⚠️</span>
          <p>{error}</p>
          <button onClick={cargarProyectos} className="btn-retry">
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="proyectos-container">
      <div className="proyectos-header">
        <div>
          <h1>Gestión de Proyectos</h1>
          <p className="subtitle">Administra y da seguimiento a todos tus proyectos</p>
        </div>
        <a href="/proyectos/nuevo" className="btn-primary">
          <span className="icon">+</span>
          Nuevo Proyecto
        </a>
      </div>

      {/* Estadísticas */}
      {estadisticas && (
        <div className="estadisticas-grid">
          <div className="stat-card">
            <div className="stat-icon" style={{ background: "#e0e7ff" }}>📊</div>
            <div className="stat-info">
              <span className="stat-label">Total</span>
              <span className="stat-value">{estadisticas.total}</span>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon" style={{ background: "#d1fae5" }}>✅</div>
            <div className="stat-info">
              <span className="stat-label">Activos</span>
              <span className="stat-value">{estadisticas.activos}</span>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon" style={{ background: "#fef3c7" }}>⏸️</div>
            <div className="stat-info">
              <span className="stat-label">Pausados</span>
              <span className="stat-value">{estadisticas.pausados}</span>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon" style={{ background: "#dbeafe" }}>🎉</div>
            <div className="stat-info">
              <span className="stat-label">Completados</span>
              <span className="stat-value">{estadisticas.completados}</span>
            </div>
          </div>
        </div>
      )}

      {/* Filtros */}
      <div className="filtros-container">
        <input
          type="text"
          name="buscar"
          placeholder="🔍 Buscar proyectos..."
          value={filtros.buscar}
          onChange={handleFiltroChange}
          className="input-buscar"
        />

        <select
          name="estado"
          value={filtros.estado}
          onChange={handleFiltroChange}
          className="select-filtro"
        >
          <option value="">Todos los estados</option>
          <option value="activo">Activo</option>
          <option value="pausado">Pausado</option>
          <option value="completado">Completado</option>
          <option value="cancelado">Cancelado</option>
        </select>

        <select
          name="prioridad"
          value={filtros.prioridad}
          onChange={handleFiltroChange}
          className="select-filtro"
        >
          <option value="">Todas las prioridades</option>
          <option value="baja">Baja</option>
          <option value="media">Media</option>
          <option value="alta">Alta</option>
          <option value="urgente">Urgente</option>
        </select>

        <input
          type="text"
          name="responsable"
          placeholder="Responsable"
          value={filtros.responsable}
          onChange={handleFiltroChange}
          className="input-filtro"
        />

        {(filtros.buscar || filtros.estado || filtros.prioridad || filtros.responsable) && (
          <button onClick={limpiarFiltros} className="btn-limpiar">
            Limpiar filtros
          </button>
        )}

        <div className="vista-toggle">
          <button
            className={vista === "tarjetas" ? "active" : ""}
            onClick={() => setVista("tarjetas")}
            title="Vista de tarjetas"
          >
            ▦
          </button>
          <button
            className={vista === "lista" ? "active" : ""}
            onClick={() => setVista("lista")}
            title="Vista de lista"
          >
            ☰
          </button>
        </div>
      </div>

      {/* Lista/Tarjetas de proyectos */}
      {proyectos.length === 0 ? (
        <div className="empty-state">
          <span className="empty-icon">📁</span>
          <h3>No hay proyectos</h3>
          <p>Comienza creando tu primer proyecto</p>
          <a href="/proyectos/nuevo" className="btn-primary">
            Crear Proyecto
          </a>
        </div>
      ) : vista === "tarjetas" ? (
        <div className="proyectos-grid">
          {proyectos.map((proyecto) => {
            const diasRestantes = calcularDiasRestantes(proyecto.fecha_fin);
            
            return (
              <div key={proyecto.id} className="proyecto-card">
                <div className="card-header">
                  <h3 className="proyecto-nombre">{proyecto.nombre}</h3>
                  <span
                    className="badge"
                    style={{ backgroundColor: getPrioridadColor(proyecto.prioridad) }}
                  >
                    {proyecto.prioridad}
                  </span>
                </div>

                {proyecto.descripcion && (
                  <p className="proyecto-descripcion">
                    {proyecto.descripcion.length > 100
                      ? `${proyecto.descripcion.substring(0, 100)}...`
                      : proyecto.descripcion}
                  </p>
                )}

                <div className="proyecto-info">
                  {proyecto.ubicacion && (
                    <div className="info-item">
                      <span className="info-icon">📍</span>
                      <span>{proyecto.ubicacion}</span>
                    </div>
                  )}
                  
                  {proyecto.responsable && (
                    <div className="info-item">
                      <span className="info-icon">👤</span>
                      <span>{proyecto.responsable}</span>
                    </div>
                  )}

                  <div className="info-item">
                    <span className="info-icon">📅</span>
                    <span>{formatearFecha(proyecto.fecha_inicio)}</span>
                  </div>

                  {proyecto.fecha_fin && (
                    <div className="info-item">
                      <span className="info-icon">🏁</span>
                      <span>{formatearFecha(proyecto.fecha_fin)}</span>
                      {diasRestantes !== null && proyecto.estado === "activo" && (
                        <span className={`dias-restantes ${diasRestantes < 0 ? "vencido" : ""}`}>
                          {diasRestantes < 0
                            ? `Vencido ${Math.abs(diasRestantes)}d`
                            : `${diasRestantes}d restantes`}
                        </span>
                      )}
                    </div>
                  )}
                </div>

              {/* Barra de progreso */}
                <div className="progreso-container">
                  <div className="progreso-header">
                    <span>Progreso</span>
                    <span className="progreso-porcentaje">{proyecto.progreso || 0}%</span>
                  </div>
                  <div className="progreso-bar">
                    <div
                      className="progreso-fill"
                      style={{
                        width: `${proyecto.progreso || 0}%`,
                        backgroundColor: getEstadoColor(proyecto.estado)
                      }}
                    ></div>
                  </div>
                </div>

                <div className="card-footer">
                  <span
                    className="estado-badge"
                    style={{ backgroundColor: getEstadoColor(proyecto.estado) }}
                  >
                    {proyecto.estado}
                  </span>
                  
                  <div className="card-actions">
                    <a
                      href={`/proyectos/${proyecto.id}`}
                      className="btn-icon"
                      title="Ver detalles"
                    >
                      👁️
                    </a>
                    <a
                      href={`/proyectos/editar/${proyecto.id}`}
                      className="btn-icon"
                      title="Editar"
                    >
                      ✏️
                    </a>
                    <a
                      href={`/proyectos/${proyecto.id}/finanzas`}
                      className="btn-icon"
                      title="Control Financiero"
                      style={{
                        background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                        color: 'white'
                      }}
                    >
                      💼
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="proyectos-lista">
          <table className="tabla-proyectos">
            <thead>
              <tr>
                <th>Proyecto</th>
                <th>Ubicación</th>
                <th>Responsable</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Progreso</th>
                <th>Prioridad</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {proyectos.map((proyecto) => (
                <tr key={proyecto.id}>
                  <td className="td-nombre">
                    <strong>{proyecto.nombre}</strong>
                  </td>
                  <td>{proyecto.ubicacion || "-"}</td>
                  <td>{proyecto.responsable || "-"}</td>
                  <td>{formatearFecha(proyecto.fecha_inicio)}</td>
                  <td>{formatearFecha(proyecto.fecha_fin)}</td>
                  <td>
                    <div className="progreso-mini">
                      <span>{proyecto.progreso || 0}%</span>
                    </div>
                  </td>
                  <td>
                    <span
                      className="badge-mini"
                      style={{ backgroundColor: getPrioridadColor(proyecto.prioridad) }}
                    >
                      {proyecto.prioridad}
                    </span>
                  </td>
                  <td>
                    <span
                      className="badge-mini"
                      style={{ backgroundColor: getEstadoColor(proyecto.estado) }}
                    >
                      {proyecto.estado}
                    </span>
                  </td>
                  <td className="td-acciones">
                    <a href={`/proyectos/${proyecto.id}`} className="btn-mini" title="Ver">
                      👁️
                    </a>
                    <a href={`/proyectos/editar/${proyecto.id}`} className="btn-mini" title="Editar">
                      ✏️
                    </a>
                    <a
                      href={`/proyectos/${proyecto.id}/finanzas`}
                      className="btn-mini"
                      title="Control Financiero"
                      style={{
                        background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                        color: 'white',
                        border: 'none'
                      }}
                    >
                      💼
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Proyectos;